<template>
  <div
    class="w-full flex items-center justify-center fixed z-50 text-white"
    style="top: 65px"
    id="network"
  >
    <div class="w-52 bg-secondary p-4 text-center">
      <span class="uppercase"> Connection lost</span>
      <br />
      Kindly check your network connection or refresh this page.
    </div>
  </div>
</template>

<script>
export default {
  name: "network-alert",
  methods: {
    hideAlert() {
      const network = document.querySelector("#network");
      network.style.display = "none";
    }
  },
  mounted() {
    setTimeout(this.hideAlert, 10000);
  }
};
</script>

<style></style>
